import { MARITAL_LOADING, GET_MARITAL, GET_MARITAL_SUCCESS, GET_MARITAL_FAIL, ADD_MARITAL_SUCCESS, ADD_MARITAL_FAIL, DELETE_MARITAL_SUCCESS, DELETE_MARITAL_FAIL, UPDATE_MARITAL_SUCCESS, UPDATE_MARITAL_FAIL, MARITAL_RESET } from "./actionType";

const INIT_STATE = {
  maritals: [],
  error: {},
};

const Marital = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_MARITAL_SUCCESS:
      switch (action.payload.actionType) {
        case GET_MARITAL:
          return {
            ...state,
            maritals: action.payload.data,
            isMaritalCreated: false,
            isMaritalSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_MARITAL_FAIL:
      switch (action.payload.actionType) {
        case GET_MARITAL_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isMaritalCreated: false,
            isMaritalSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_MARITAL: {
      return {
        ...state,
        isMaritalCreated: false,
        loading: true,
      };
    }

    case MARITAL_LOADING: {
      return {
        ...state,
        isMaritalCreated: false,
        loading: true,
      };
    }

    case ADD_MARITAL_SUCCESS:
      return {
        ...state,
        isMaritalCreated: true,
        loading: false,
        maritals: [action.payload.data, ...state.maritals],
      };

    case ADD_MARITAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_MARITAL_SUCCESS:
      return {
        ...state,
        loading: false,
        maritals: state.maritals.filter((marital) => marital.id.toString() !== action.payload.id.toString()),
      };

    case DELETE_MARITAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_MARITAL_SUCCESS:
      return {
        ...state,
        loading: false,
        maritals: state.maritals.map((marital) => (marital.id.toString() === action.payload.data.id.toString() ? { ...marital, ...action.payload.data } : marital)),
      };

    case UPDATE_MARITAL_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case MARITAL_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default Marital;
